export enum FormControlType {
	Text,
	Password
}
